import React, { useState} from 'react';

import './styles/NegotiationsCalculator.css';

import { Center, Icon, Input, Field, Flex, Heading, InputGroup, NumberInput } from "@chakra-ui/react"

import { FaCalculator, FaDollarSign, FaEllipsis } from "react-icons/fa6";

function NegotiationsCalculator() {

    interface OfferForm {
        baseSalary: number,
        rsuGrant: number,
        annualBonus: number,
        signOnBonus: number,
    }

    const [initialOffer, setInitialOffer] = useState([]);
    const [finalOffer, setFinalOffer] = useState([]);

    const handleInitialOfferChange = (e: any) => {
        initialOffer[e.target.name] = e.target.value;
    }

    const handleFinalOfferChange = (e: any) => {
        finalOffer[e.target.name] = e.target.value;
    }

    return (
        // Need to use this trick so we jump to the offset of navigation bar
        <div style={{
            paddingTop: '69px',
            marginTop: '-69px',
        }}
        id='commissioncalculator'>
            {/* Desktop only view */}
            <Flex 
                className="negotiations_calculator__parent"
                direction='column'
                gap='8'
            >
                <Flex
                    direction='column'
                    gap='2'
                >
                    <Heading
                        color='black'
                        fontWeight='bold'
                        size='4xl'
                    >
                        <Flex gap='2' justifyContent='center'>
                            <FaCalculator color='#FB5383' style={{marginTop:'4px'}}/> Commission Calculator
                        </Flex>
                    </Heading>
                    <Heading color='gray' size='md' style={{marginTop: '10px'}}>
                        Model what an increased offer could look like and how our pricing would change
                    </Heading>
                </Flex>
                <Flex gap='16' justify='center' style={{marginTop: '25px'}}>
                    <Flex direction='column' gap='6'>
                        <Heading color='black' size='xl'>
                            Initial Offer
                        </Heading>
                        <Flex direction='column' gap='2'>
                            <Flex className='negotiations_calculator__initial_offer_parent' justifyContent='center'>
                                <Flex
                                    direction='column'
                                    gap='3'
                                >
                                    <Field.Root>
                                        <Field.Label color='black'>Base Salary</Field.Label>
                                        <NumberInput.Root width="350px">
                                            <InputGroup startElement={<FaDollarSign />}>
                                                <NumberInput.Input className='negotiations_calculator__initial_offer_input'/>
                                            </InputGroup>
                                        </NumberInput.Root>
                                        <Field.HelperText color='black'>Enter your annual base salary</Field.HelperText>
                                    </Field.Root>
                                    {/* <Flex justify='space-between'> */}
                                        {/* <Field.Root width='230px'> */}
                                        <Field.Root>
                                            <Field.Label color='black'>RSU Grant</Field.Label>
                                            <NumberInput.Root width='350px'>
                                            <InputGroup startElement={<FaDollarSign />}>
                                                <NumberInput.Input className='negotiations_calculator__initial_offer_input'/>
                                            </InputGroup>
                                        </NumberInput.Root>
                                            <Field.HelperText color='black'>Enter your total RSU grant</Field.HelperText>
                                        </Field.Root>
                                        {/* <Field.Root width='120px'>
                                            <Field.Label color='black'>RSU Years</Field.Label>
                                            <NumberInput.Root>
                                                <NumberInput.Input className='negotiations_calculator__initial_offer_input'/>
                                            </NumberInput.Root>
                                            <Field.HelperText color='black' textAlign='left'>Number of years your grant vests over</Field.HelperText>
                                        </Field.Root> */}
                                    {/* </Flex> */}
                                    <Field.Root>
                                        <Field.Label color='black'>Annual Bonus</Field.Label>
                                        <NumberInput.Root width="350px">
                                            <InputGroup startElement={<FaDollarSign />}>
                                                <NumberInput.Input className='negotiations_calculator__initial_offer_input'/>
                                            </InputGroup>
                                        </NumberInput.Root>
                                        <Field.HelperText color='black'>Enter your annual base salary</Field.HelperText>
                                    </Field.Root>
                                    <Field.Root>
                                        <Field.Label color='black'>Sign on Bonus</Field.Label>
                                        <NumberInput.Root width="350px">
                                            <InputGroup startElement={<FaDollarSign />}>
                                                <NumberInput.Input className='negotiations_calculator__initial_offer_input'/>
                                            </InputGroup>
                                        </NumberInput.Root>
                                        <Field.HelperText color='black'>Enter any one-time sign on bonus</Field.HelperText>
                                    </Field.Root>
                                </Flex>
                            </Flex>
                            <Heading color='black' fontWeight='normal' size='xs'>
                                Have a unique offer structure? Reach out for a custom quote
                            </Heading>
                        </Flex>
                    </Flex>
                    <Flex direction='column' gap='6'>
                        <Heading color='black' size='xl'>
                            Negotiated Offer
                        </Heading>
                        <Flex className='negotiations_calculator__negotiated_offer_parent' justifyContent='center'>
                            <Flex
                                direction='column'
                                gap='3'
                            >
                                <Field.Root>
                                    <Field.Label color='black' className='negotiations_calculator__negotiated_offer_input_label'>Base Salary</Field.Label>
                                    <NumberInput.Root width="350px">
                                        <InputGroup startElement={<FaDollarSign className='negotiations_calculator__negotiated_offer_input_label' />}>
                                            <NumberInput.Input className='negotiations_calculator__negotiated_offer_input'/>
                                        </InputGroup>
                                    </NumberInput.Root>
                                    <Field.HelperText color='black' className='negotiations_calculator__negotiated_offer_input_label'>Enter your annual base salary</Field.HelperText>
                                </Field.Root>
                                {/* <Flex justify='space-between'> */}
                                <Field.Root width='350px'>
                                    <Field.Label color='black' className='negotiations_calculator__negotiated_offer_input_label'>RSU Grant</Field.Label>
                                    <NumberInput.Root width='350px'>
                                        <InputGroup startElement={<FaDollarSign className='negotiations_calculator__negotiated_offer_input_label'/>}>
                                            <NumberInput.Input className='negotiations_calculator__negotiated_offer_input'/>
                                        </InputGroup>
                                    </NumberInput.Root>
                                    <Field.HelperText color='black' className='negotiations_calculator__negotiated_offer_input_label'>Enter your total RSU grant</Field.HelperText>
                                </Field.Root>
                                <Field.Root>
                                    <Field.Label color='black' className='negotiations_calculator__negotiated_offer_input_label'>Annual Bonus</Field.Label>
                                    <NumberInput.Root width="350px">
                                        <InputGroup startElement={<FaDollarSign className='negotiations_calculator__negotiated_offer_input_label'/>}>
                                            <NumberInput.Input className='negotiations_calculator__negotiated_offer_input'/>
                                        </InputGroup>
                                    </NumberInput.Root>
                                    <Field.HelperText color='black' className='negotiations_calculator__negotiated_offer_input_label'>Enter your annual base salary</Field.HelperText>
                                </Field.Root>
                                <Field.Root>
                                    <Field.Label color='black' className='negotiations_calculator__negotiated_offer_input_label'>Sign on Bonus</Field.Label>
                                    <NumberInput.Root width="350px">
                                        <InputGroup startElement={<FaDollarSign className='negotiations_calculator__negotiated_offer_input_label'/>}>
                                            <NumberInput.Input className='negotiations_calculator__negotiated_offer_input'/>
                                        </InputGroup>
                                    </NumberInput.Root>
                                    <Field.HelperText color='black' className='negotiations_calculator__negotiated_offer_input_label'>Enter any one-time sign on bonus</Field.HelperText>
                                </Field.Root>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
                <Flex direction='column' gap='2' style={{marginTop: '40px'}}>
                    <Heading color='black'>
                        Your total increase would be $X.
                    </Heading>
                    <Heading color='black'>
                        Our commission would be $Y.
                    </Heading>
                </Flex>
            </Flex>

            {/* Mobile only view */}
            <Flex className="negotiations_calculator__mobile_parent" >
                <Flex direction='column' gap='2' >
                    <Flex gap='2' justifyContent='center'>
                        {/* <Icon size='lg'> */}
                            <FaCalculator color='#FB5383' style={{marginTop:'7px', height:'25px'}} /> 
                        {/* </Icon> */}
                        <Heading
                            color='black'
                            fontWeight='bold'
                            size='3xl'
                        >
                            Commission Calculator
                        </Heading>
                    </Flex>
                    <Heading color='gray' size='sm' style={{marginTop: '10px'}}>
                        Model what an increased offer could look like and how our pricing would change
                    </Heading>
                </Flex>
                <Flex direction='column' gap='6' justify='center' style={{marginTop: '20px'}}>
                    <Flex direction='column' gap='6'>
                        <Heading color='black' size='xl'>
                            Initial Offer
                        </Heading>
                        <Flex direction='column' gap='2'>
                            <Flex direction='column' className='negotiations_calculator__initial_offer_parent' gap='3'>
                                <Field.Root >
                                    <Field.Label color='black'>Base Salary</Field.Label>
                                    <InputGroup startElement={<FaDollarSign />}>
                                        <Input color='black'  className='negotiations_calculator__initial_offer_input'/>
                                    </InputGroup>
                                    <Field.HelperText color='black'>Enter your annual base salary</Field.HelperText>
                                </Field.Root>
                                {/* <Flex justify='space-between'> */}
                                    {/* <Field.Root width='230px'> */}
                                    <Field.Root>
                                        <Field.Label color='black'>RSU Grant</Field.Label>
                                        <InputGroup startElement={<FaDollarSign />}>
                                            <Input color='black'  className='negotiations_calculator__initial_offer_input'/>
                                        </InputGroup>
                                        <Field.HelperText color='black'>Enter your total RSU grant</Field.HelperText>
                                    </Field.Root>
                                <Field.Root>
                                    <Field.Label color='black'>Annual Bonus</Field.Label>
                                    <InputGroup startElement={<FaDollarSign />}>
                                        <Input color='black'  className='negotiations_calculator__initial_offer_input'/>
                                    </InputGroup>
                                    <Field.HelperText color='black'>Enter your annual base salary</Field.HelperText>
                                </Field.Root>
                                <Field.Root>
                                    <Field.Label color='black'>Sign on Bonus</Field.Label>
                                    <InputGroup startElement={<FaDollarSign />}>
                                        <Input color='black'  className='negotiations_calculator__initial_offer_input'/>
                                    </InputGroup>
                                    <Field.HelperText color='black'>Enter any one-time sign on bonus</Field.HelperText>
                                </Field.Root>
                            </Flex>
                            <Heading color='black' fontWeight='normal' size='xs'>
                                Have a unique offer structure? Reach out for a custom quote
                            </Heading>
                        </Flex>
                    </Flex>
                    <Center>
                        <Icon color='#FB5383'>
                            <FaEllipsis/>
                        </Icon>
                    </Center>
                    <Flex direction='column' gap='6'>
                        <Heading color='black' size='xl'>
                            Negotiated Offer
                        </Heading>
                        <Flex direction='column' className='negotiations_calculator__negotiated_offer_parent' justifyContent='center' gap='3'>

                            <Field.Root>
                                <Field.Label color='black' className='negotiations_calculator__negotiated_offer_input_label'>Base Salary</Field.Label>
                                <InputGroup startElement={<FaDollarSign className='negotiations_calculator__negotiated_offer_input_label'/>}>
                                    <Input color='black'  type='number' className='negotiations_calculator__negotiated_offer_input'/>
                                </InputGroup>
                                <Field.HelperText color='gray'>
                                    Enter your annual base salary
                                </Field.HelperText>
                            </Field.Root>
                            <Field.Root >
                                <Field.Label color='black' className='negotiations_calculator__negotiated_offer_input_label'>RSU Grant</Field.Label>
                                <InputGroup startElement={<FaDollarSign className='negotiations_calculator__negotiated_offer_input_label'/>}>
                                    <Input color='black' className='negotiations_calculator__negotiated_offer_input'/>
                                </InputGroup>
                                <Field.HelperText color='gray' className='negotiations_calculator__negotiated_offer_input_label'>Enter your total RSU grant</Field.HelperText>
                            </Field.Root>
                            <Field.Root>
                                <Field.Label color='black' className='negotiations_calculator__negotiated_offer_input_label'>Annual Bonus</Field.Label>
                                <InputGroup startElement={<FaDollarSign className='negotiations_calculator__negotiated_offer_input_label'/>}>
                                    <Input color='black'  className='negotiations_calculator__negotiated_offer_input'/>
                                </InputGroup>
                                <Field.HelperText color='gray' className='negotiations_calculator__negotiated_offer_input_label'>Enter your annual base salary</Field.HelperText>
                            </Field.Root>
                            <Field.Root>
                                <Field.Label color='black' className='negotiations_calculator__negotiated_offer_input_label'>Sign on Bonus</Field.Label>
                                <InputGroup startElement={<FaDollarSign className='negotiations_calculator__negotiated_offer_input_label'/>}>
                                    <Input color='black'  className='negotiations_calculator__negotiated_offer_input'/>
                                </InputGroup>
                                <Field.HelperText color='black' className='negotiations_calculator__negotiated_offer_input_label'>Enter any one-time sign on bonus</Field.HelperText>
                            </Field.Root>
                        </Flex>
                    </Flex>
                </Flex>
                <Flex direction='column' gap='2' style={{marginTop: '30px'}}>
                    <Heading color='black'>
                        Your total increase would be $X.
                    </Heading>
                    <Heading color='black'>
                        Our commission would be $Y.
                    </Heading>
                </Flex>
            </Flex>
        </div>
    );
}

export default NegotiationsCalculator;
